module.exports = __webpack_public_path__ + "static/media/S1N1-1.fb490ed7.svg";